import { createBrowserRouter } from "react-router-dom";
import { lazy, Suspense } from "react";
//import ErrorPage from "./pages/ErrorPage";
import MainLayout from "./layout/Main";

// Lazy load all route components for code splitting
const HomePage = lazy(() => import("./pages/home/Home"));
const AboutPage = lazy(() => import("./pages/about/About"));
const ContactPage = lazy(() => import("./pages/contact/Contact"));
const TeamPage = lazy(() => import("./pages/team/Team"));
const ClaimsPage = lazy(() => import("./pages/claims/Claims"));
const ResourcesPage = lazy(() => import("./pages/about/Resources"));
const FormsPage = lazy(() => import("./pages/about/Forms"));
const AffilationPage = lazy(() => import("./pages/about/Affiliation"));
const ProductPage = lazy(() => import("./pages/products/Products"));
const SpecificStopLossPage = lazy(() => import("./pages/products/SpecificStopLoss"));
const MonthlyPage = lazy(() => import("./pages/products/Monthly"));
const AggregateStopLossPage = lazy(() => import("./pages/products/AggregateStopLoss"));
const ALaCartePage = lazy(() => import("./pages/services/ALaCarte"));
const CapitalPage = lazy(() => import("./pages/services/Capital"));
const ClaimsPage2 = lazy(() => import("./pages/services/Claims"));
const UnderwritingPage = lazy(() => import("./pages/services/Underwriting"));
const EboniScottPage = lazy(() => import("./pages/team/EboniScott"));
const TestimonialsPage = lazy(() => import("./pages/about/Testimonials"));
const ViewPdf = lazy(() => import("./sections/resources-sections/ViewForm"));
const PDFView = lazy(() => import("./components/PDFViewer"));
const HeaderPreviewPage = lazy(() => import("./pages/preview/HeaderPreview"));
const PressPage = lazy(() => import("./pages/press/Press"));

// Loading fallback component
const PageLoader = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="text-center">
      <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      <p className="mt-4 text-gray-600">Loading...</p>
    </div>
  </div>
);

// Wrapper component for Suspense
const SuspenseWrapper = ({ children }) => (
  <Suspense fallback={<PageLoader />}>
    {children}
  </Suspense>
);


const router = createBrowserRouter([
  {
    path: "/",
    element: <SuspenseWrapper><HomePage /></SuspenseWrapper>,
    //errorElement: <ErrorPage />,
  },
  {
    path: "/about",
    element: <SuspenseWrapper><AboutPage /></SuspenseWrapper>,
    //errorElement: <ErrorPage />,
  },
  {
    path: "/about/team/:id",
    element: <SuspenseWrapper><EboniScottPage /></SuspenseWrapper>,
    //errorElement: <ErrorPage />,
  },
  {
    path: "/testimonials",
    element: <SuspenseWrapper><TestimonialsPage /></SuspenseWrapper>
  },
  {
    path: "/about/resources",
    element: <SuspenseWrapper><ResourcesPage /></SuspenseWrapper>,
    //errorElement: <ErrorPage />,
  },
  {
    path: "/about/forms",
    element: <SuspenseWrapper><FormsPage /></SuspenseWrapper>,
    //errorElement: <ErrorPage />,
  },
  {
    path: "/forms/:id",
    element: <SuspenseWrapper><PDFView /></SuspenseWrapper>,
    //errorElement: <ErrorPage />,
  },
  {
    path: "/about/affiliation",
    element: <SuspenseWrapper><AffilationPage /></SuspenseWrapper>,
    //errorElement: <ErrorPage />,
  },
  {
    path: "/contact",
    element: <SuspenseWrapper><ContactPage /></SuspenseWrapper>,
    //errorElement: <ErrorPage />,
  },
  {
    path: "/about/team",
    element: <SuspenseWrapper><TeamPage /></SuspenseWrapper>,
    //errorElement: <ErrorPage />,
  },
  {
    path: "/product",
    element: <SuspenseWrapper><ProductPage /></SuspenseWrapper>,
    //errorElement: <ErrorPage />,
  },
  {
    path: "/product/specific-stop-loss",
    element: <SuspenseWrapper><SpecificStopLossPage /></SuspenseWrapper>,
    //errorElement: <ErrorPage />,
  },
  {
    path: "/product/aggregate-stop-loss",
    element: <SuspenseWrapper><AggregateStopLossPage /></SuspenseWrapper>,
    //errorElement: <ErrorPage />,
  },
  {
    path: "/product/monthly-accomadation",
    element: <SuspenseWrapper><MonthlyPage /></SuspenseWrapper>,
    //errorElement: <ErrorPage />,
  },
  {
    path: "/services",
    element: <SuspenseWrapper><ProductPage /></SuspenseWrapper>,
    //errorElement: <ErrorPage />,
  },
  {
    path: "/services/a-la-carte",
    element: <SuspenseWrapper><ALaCartePage /></SuspenseWrapper>,
    //errorElement: <ErrorPage />,
  },
  {
    path: "/services/claims",
    element: <SuspenseWrapper><ClaimsPage2 /></SuspenseWrapper>,
    //errorElement: <ErrorPage />,
  },
  {
    path: "/services/underwriting",
    element: <SuspenseWrapper><UnderwritingPage /></SuspenseWrapper>,
    //errorElement: <ErrorPage />,
  },
  {
    path: "/services/capital-funding",
    element: <SuspenseWrapper><CapitalPage /></SuspenseWrapper>,
    //errorElement: <ErrorPage />,
  },
  {
    path: "/claims",
    element: <SuspenseWrapper><ClaimsPage /></SuspenseWrapper>,
    //errorElement: <ErrorPage />,
  },
  {
    path: "/request-a-quote",
    element: <SuspenseWrapper><ContactPage /></SuspenseWrapper>,
    //errorElement: <ErrorPage />,
  },
  {
    path: "/header-preview",
    element: <SuspenseWrapper><HeaderPreviewPage /></SuspenseWrapper>,
  },
  {
    path: "/press",
    element: <SuspenseWrapper><PressPage /></SuspenseWrapper>,
  },

]);

export default router;